module.exports = __webpack_public_path__ + "img/loading.775eae2.gif";